import{gql as o}from"@apollo/client";const e=o`
  mutation removeMfaKey($code: String!) {
    mfa {
      remove(code: $code)
    }
  }
`;export{e as REMOVE_MFA_KEY};
//# sourceMappingURL=useRemoveMfaKey.graphql.js.map
